import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Mail, Linkedin, Twitter } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { content } = useLanguage();
  const { ui } = content;
  const { footer } = ui;

  return (
    <footer className="bg-black border-t border-gray-900">
      {/* CTA Section */}
      <div className="border-b border-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
              {footer.ctaTitle}
            </h2>
            <p className="text-lg text-gray-400 mb-8">
              {footer.ctaSubtitle}
            </p>
            <Button
              asChild
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg transition-all duration-200 hover:scale-105"
            >
              <a href="#tecnologia">
                {footer.ctaButton}
                <ArrowRight className="ml-2" size={20} />
              </a>
            </Button>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="text-2xl font-bold text-white mb-4">{ui.logo}</div>
            <p className="text-gray-400 mb-6 max-w-md">
              {footer.description}
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-gray-900 hover:bg-gray-800 rounded-lg flex items-center justify-center transition-colors duration-200"
              >
                <Linkedin size={20} className="text-gray-400" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-900 hover:bg-gray-800 rounded-lg flex items-center justify-center transition-colors duration-200"
              >
                <Twitter size={20} className="text-gray-400" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-900 hover:bg-gray-800 rounded-lg flex items-center justify-center transition-colors duration-200"
              >
                <Mail size={20} className="text-gray-400" />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-semibold mb-4">{footer.productsHeading}</h3>
            <ul className="space-y-3">
              {footer.productLinks.map((label) => (
                <li key={label}>
                  <a href="#productos" className="text-gray-400 hover:text-white transition-colors duration-200">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">{footer.companyHeading}</h3>
            <ul className="space-y-3">
              {footer.companyLinks.map((label) => (
                <li key={label}>
                  <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-900 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            {footer.rightsReserved(currentYear)}
          </p>
          <div className="flex space-x-6 text-sm">
            {footer.legalLinks.map((label) => (
              <a key={label} href="#" className="text-gray-500 hover:text-white transition-colors duration-200">
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
